import tw from "twin.macro";

export const SectionDescription = tw.p`mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed  text-stone-100 max-w-xl`;
